// extracted by mini-css-extract-plugin
export default {"dog":"dog_dog__-gdTr","button":"dog_button__pHoA0"};